import MailFolderTableQuery from '../../store/schema/MailFolderTableQuery';
import SearchTableQuery from '../../store/schema/SearchTableQuery';
import TableQuery, { TableQueryType } from '../../store/schema/TableQuery';

export default function getTableId(tableQuery: TableQuery): string {
    const tableId = [];
    switch (tableQuery.type) {
        case TableQueryType.Folder:
            tableId.push('folderId:' + tableQuery.folderId);

            const mailTableQuery = tableQuery as MailFolderTableQuery;
            tableId.push('listViewType:' + tableQuery.listViewType);
            tableId.push('viewFilter:' + mailTableQuery.viewFilter);
            tableId.push('focusedViewFilter:' + mailTableQuery.focusedViewFilter);
            break;

        case TableQueryType.Search:
            tableId.push('folderId:' + tableQuery.folderId);

            const searchTableQuery = tableQuery as SearchTableQuery;
            tableId.push('id:' + searchTableQuery.searchNumber);
            tableId.push('query:' + searchTableQuery.queryString);
            break;
    }

    return tableId.join(';').toString();
}
